<div class="tabs-container" [hidden]="showingDetail">
    <tabs (tabClicked)="onTabClicked()">
        <tab title="Incomplete">
            <span class="expedited-swatch">= Expedited</span>
            <ag-grid-angular class="data-grid " [rowData]="incompletePermitApplications" [gridOptions]="incompleteGridOptions" [attr.aria-label]="widgetTitle + ' - Incomplete'"></ag-grid-angular>
        </tab>
        <tab title="First">
            <span class="expedited-swatch">= Expedited</span>
            <ag-grid-angular class="data-grid " [rowData]="permitFirstLevelPendingFlows" [gridOptions]="firstLevelReviewGridOptions" [attr.aria-label]="widgetTitle + ' - First'">
            </ag-grid-angular>
        </tab>

        <tab title="Peer">
            <span class="expedited-swatch"> = Expedited</span>
            <ag-grid-angular class="data-grid " [rowData]="permitSecondLevelPendingFlows" [gridOptions]="secondLevelReviewGridOptions" [attr.aria-label]="widgetTitle + ' - Peer'">
            </ag-grid-angular>
        </tab>

        <tab title="Ad Hoc">
            <span class="expedited-swatch"> = Expedited</span>
            <ag-grid-angular class="data-grid " [rowData]="permitAdHocReviewPendingFlows" [gridOptions]="adHocReviewGridOptions" [attr.aria-label]="widgetTitle + ' - Ad Hoc'">
            </ag-grid-angular>
        </tab>

        <tab title="Final">
            <span class="expedited-swatch"> = Expedited</span>
            <ag-grid-angular class="data-grid " [rowData]="permitThirdLevelPendingFlows" [gridOptions]="thirdLevelReviewGridOptions" [attr.aria-label]="widgetTitle + ' - Final'">
            </ag-grid-angular>
        </tab>

        <tab title="Pending Denials">
            <span class="expedited-swatch"> = Expedited</span>
            <ag-grid-angular class="data-grid " [rowData]="pendingDenialData" [gridOptions]="pendingDenialGridOptions" [attr.aria-label]="widgetTitle + ' - Pending Denials'">
            </ag-grid-angular>
        </tab>

        <tab title="Returned for Corrections">
            <span class="expedited-swatch"> = Expedited</span>
            <ag-grid-angular class="data-grid " [rowData]="returnedData" [gridOptions]="returnedGridOptions" [attr.aria-label]="widgetTitle + ' - Returned for Corrections'">
            </ag-grid-angular>
        </tab>
    </tabs>
</div>